import React from 'react';
import { ReactComponent as ErrorIcon } from 'assets/svgs/error404.svg';

export const NotFoundPage = () => {
  return <ErrorIcon />;
};
